module.exports = __webpack_public_path__ + "fonts/Gilroy-UltraLightItalic.f07d7e71.woff";